import script from "./fileUploadImg.vue?vue&type=script&setup=true&lang=js"
export * from "./fileUploadImg.vue?vue&type=script&setup=true&lang=js"

import "./fileUploadImg.vue?vue&type=style&index=0&id=34a91f2a&lang=scss"

const __exports__ = script;

export default __exports__